import type { Environment } from './environment.interface';
import { StrapiGraphQLURL, StrapiAssetsURL } from './../app/shared/interfaces/strapi-urls.enum';

import { APIErrorInterceptor } from '../app/core/interceptor/api-error.interceptor';
import { HeaderInterceptor } from '../app/core/interceptor/header.interceptor';

export const environment: Environment = {
  name: 'production',
  deployUrl: '/help/check',
  production: true,
  transferState: true,
  authConfig: {
    issuer: 'https://oauth.virginmedia.com',
    tokenEndpoint: 'https://oauth.virginmedia.com/as/token.oauth2',
    loginUrl: 'https://oauth.virginmedia.com/as/authorization.oauth2',
    redirectUri: '/help/check/auth-deflection',
    clientId: 'WEB-VM-SPAGEN1',
    dummyClientSecret: 'STIVky6gPeExyvoCSdhhwngrT5CrDpzdcDgUVITesYGVSrelts8eVa2r6fLwoo1z',
    responseType: 'code',
    scope: 'spagen openid',
    grantType: 'client_credentials',
    sessionChecksEnabled: true,
    useSilentRefresh: true,
  },
  strapi: {
    image_url: StrapiAssetsURL.PROD,
    graphql_url: StrapiGraphQLURL.PROD,
  },
  gcp: {
    baseUrl: 'https://api.vmo2digital.co.uk',
    identificationUrl: '/faults/workflow/v1/identify',
    outagesUrl: '/faults/workflow-service-status/v1',
    applyCompensation: '/faults/workflow-service-status/v1/apply-for-compensation',
    applyUpdates: '/faults/workflow-service-status/v1/apply-for-notification',
    dapiChannelId: 'Care-SelfCare-WEB',
    dapiClientSecret: 'lnlzYDi9zqxr7NiLS1N7YZPZ1tNN27uK1yY7ktRveZZGAMhaRGmkNd3o3iQRQHI8',
    dapiAppId: 'PR2HJ4yVbIK6vg0uQLXvqR1GjNX40gLOxkFoKMYeGGlGBrZC',
    oauthServer: 'oAuth',
    bookingAnEngineer: {
      cancelAppointment: '/faults/workflow/v1/orders/cancel',
      workOrder: '/faults/workflow/v1/orders',
      reschedule: '/faults/workflow/v1/orders/reschedule',
      getAppointments: '/faults/workflow/v1/appointments',
    },
    diagnostics: {
      accountCheck: '/faults/workflow/v1/account-check',
      diagnosticCheck: '/faults/workflow/v1',
    },
    pinHoleReset: {
      start: '/faults/workflow/v1/hub/action/start',
      retrieve: '/faults/workflow/v1/hub/action/retrieve/',
    },
    otpEndpoints: {
      create: '/faults/workflow/v1/otp-create',
      verify: '/faults/workflow/v1/otp-verify',
      info: '/faults/workflow/v1/customer-info',
    },
    customerInfo: '/faults/workflow/v1/customer-info',
  },
  apigeeApi: {
    baseUrl: 'https://api.vmo2digital.co.uk/cpx/',
    dapiAppId: 'La5KYUY4rsEhSCRA3c91ql3lqCBE8erCkw1f1UHpj7FArnJT',
    dapiClientSecret: 'VmyL8ycOZN3jekPmralMubWVTJvdwhVpaOxdA00FFA3aDA8sk879rbbX0SATrMAh',
    dapiChannelId: 'Care-Faults-Service',
    clientId: 'Digital-Service-Status',
    clientSecret: '9XjT62HCGvMUVRhz',
  },
  compaxAngularApi: {
    frontendTokenUrl: '/vm-auth-service/pingfed-auth',
    sessionData: 'session-data',
    findCustomer: 'account/find-by-address',
    serviceStatus: 'diagnostics/service-status',
    findByIp: 'account/find-by-ip',
    compRegApi: 'diagnostics/auto-compensation/registration',
    notificationsRegApi: 'diagnostics/notification/subscribe',
    setSession: 'diagnostics/set-session',
    compaxToken: {
      registerTokenURl: 'vm-auth-service/register-token',
    },
    authToken: {
      url: 'vm-auth-service/oauth/token',
      clientId: 'compax',
      clientSecret: 'compax1',
      grantType: 'client_credentials',
      contentType: 'application/x-www-form-urlencoded',
    },
    workflowEndpoints: {
      start: 'workflow/start',
      current: 'workflow/current',
      back: 'workflow/back',
      next: 'workflow/next',
      nextReturnCode: 'workflow/set-next-returncode',
      goToNextReturnCode: 'workflow/go-to-next-returncode',
      check: 'workflow/check',
    },
    manageTransactionData: {
      retrieve: 'account/manage-transaction-data/retrieve',
      create: 'account/manage-transaction-data/create',
    },
  },
  featureFlags: {
    tvDiagnosticsEnabled: true,
    podHealthIssuesEnabled: true,
  },
  interceptors: [HeaderInterceptor, APIErrorInterceptor],
  storyblok: {
    accessToken: 'WtUrARsr4bsjypx0TmSdbwtt',
    region: 'eu',
  },
  diagnosticCheckDivisor: 1,
};
